import { appstr } from "../utils/appstr";
import { QStream } from "./QStream.js";
import { QGetExcelDataRFC } from "./QGetExcelDataRFC";
import { QLookupObj } from "../utils/QLookupObj";
import { QXMLLoader } from "./QXMLLoader";
import { Globals } from "./Globals";
import { QMissingRef } from "./QMissingRef.js";

export class QRefMgr {
  constructor() {
    this.fWSMgr = null;
    this.fFileName = null;
    this.fLoaded = false;
    this.fLookup = null;
    this.fActive = false;
    this.fRecordMissing = false;
    this.fMissingList = null;
  }

  InitRefMgr(wsMgr) {
    this.fWSMgr = wsMgr;
  }

  SetFileName(fileName) {
    this.fFileName = fileName;
  }

  SetActive(isActive) {
    this.fActive = isActive;
  }

  RecordMissing(recordMissing) {
    this.fRecordMissing = recordMissing;
    this.fMissingList = new Array();
  }

  GetMissingList() {
    return this.fMissingList;
  }

  LoadRefMgr() {
    this.GetRefTable(this.fFileName);
  }

  GetRefTable(fileName) {
    var directory = "Reference";
    var downloadRFC = new QGetExcelDataRFC();
    downloadRFC.InitGetExcelDataRFC(this, fileName, directory);

    var w = this.fWSMgr;
    var org = w.GetAccountName();
    var user = w.GetUserName();

    downloadRFC.SetParams(org, user, fileName, directory, null);
    Globals._rfcMgr.QueueRFC(downloadRFC);
  }

  CreateLookupTable(objTree) {
    this.fLookup = new QLookupObj();

    var childList = objTree.GetChildOfTypeList("r");
    var n2 = childList.length;
    for (var i = 0; i < n2; i++) {
      var r = childList[i];
      var childList2 = r.GetChildOfTypeList("d");
      var dl = childList2.length;
      if (dl == 4) {
        var key1 = childList2[0];
        var key2 = childList2[1];
        var key3 = childList2[2];
        var result = childList2[3];
        var k1 = key1.GetValue();
        var k2 = key2.GetValue();
        var k3 = key3.GetValue();
        var v = result.GetValue();
        var key = k1.toString() + k2.toString().toLowerCase() + k3.toString().toLowerCase();
        //   key = key.toLowerCase();
        this.fLookup[key] = v;
      }
    }
  }

  GetExcelDataResult(success, theData, fileName, directory) {
    if (success) {
      var s = new QStream();
      s.InitStreamFromXML(theData);
      var loader = new QXMLLoader();
      var objTree = loader.LoadXML(s);
      this.CreateLookupTable(objTree);
    } else {
    }

    this.SetLoaded();

    var w = this.fWSMgr;
    w.PrepRenderWS();
    w.RenderWS();
  }

  SetLoaded() {
    this.fLoaded = true;
  }

  GetTopBoxID() {
    var topID = null;
    var topObj = null;

    var docMgr = this.fWSMgr.GetDocMgr();
    var curDoc = docMgr.GetCurrentDoc();
    var scm = curDoc.GetSubChartMgr();
    var sc = scm.GetActiveSubChart();
    if (sc != null) {
      topObj = sc.GetTopDBObj();
      if (topObj != null) topID = topObj.GetObjectRecordID();
    }

    return topID;
  }

  LookupVar(varName, dbObj) {
    var s = null;
    varName = varName.toLowerCase();
    switch (varName) {
      case "$division":
        var docMgr = this.fWSMgr.GetDocMgr();
        var curDoc = docMgr.GetCurrentDoc();
        s = curDoc.GetDivisionName();
        break;
      case "$topboxid":
        s = this.GetTopBoxID();
        break;
    }

    if (s == null && dbObj != null) {
      var isFieldRef = varName.indexOf("$field");
      if (isFieldRef == 0) {
        var parts = varName.split(":");
        if (parts.length == 2) {
          var fieldDef = dbObj.GetFieldDefByName(parts[1]);
          if (fieldDef != null) {
            var v = dbObj.GetFieldValue(fieldDef);
            if (v != null) s = v.toString();
          }
        }
      }
    }

    return s;
  }

  RecordMissingRef(key1, key2, key3) {
    if (!this.fRecordMissing) return;

    var m = new QMissingRef(key1, key2, key3);
    this.fMissingList.push(m);
  }

  RefNotFound(key1, key2, key3) {
    var lookup = key1 + key2 + "*";
    var v = this.fLookup[lookup];
    if (v == null) {
      lookup = key1 + "*";
      v = this.fLookup[lookup];
      if (v == null) {
        lookup = "*";
        v = this.fLookup[lookup];
        if (v == null) {
          this.RecordMissingRef(key1, key2, key3);
          return appstr("refnotfound");
        }
      }
    }

    return v;
  }

  ResolveReference(theReference, dbObj) {
    if (!this.fActive) return appstr("refnotconfig");

    if (!this.fLoaded) return appstr("loading");

    theReference = theReference.toString();

    var l = theReference.length;
    var r = theReference.substring(2, l - 1);
    var parts = r.split(".");
    var numParts = parts.length;

    var key1 = parts[0];
    var k1Len = key1.length;
    if (k1Len == 0) return appstr("refinvalid");

    var key2 = "";
    var key3 = "";

    if (numParts > 1) key2 = parts[1];
    if (numParts > 2) key3 = parts[2];

    var isVar = false;
    if (key1[0] == "$") {
      key1 = this.LookupVar(key1, dbObj);
      if (key1 == null) return appstr("refinvalid");
      else isVar = true;
    }

    if (key2[0] == "$") {
      key2 = this.LookupVar(key2, dbObj);
      if (key2 == null) return appstr("refinvalid");
    }

    var key2 = key2.toLowerCase();
    var key3 = key3.toLowerCase();
    var lookup = key1 + key2 + key3;
    //   lookup = lookup.toLowerCase();

    if (this.fLookup) {
      var v = this.fLookup[lookup];
      if (v == null) {
        if (key2.length == 0 && isVar) return key1;
        else return this.RefNotFound(key1, key2, key3); // appstr("refnotfound");
      }
    } else return appstr("refnotfound");

    return v;
  }
}
